module.exports = __webpack_public_path__ + "img/scb.3edd82a1.png";